export default __webpack_public_path__ + "static/button-action-dont-dark-4620709f34e514d9b2c9dcd475d983ae.png";